/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { patchCustomerById, postNewCustomer } from "./core/_request";
import { ActionedCustomer } from "./store/CustomerStore";

const RoleSchema = Yup.object().shape({
  name: Yup.string().required("Nom et prénom obligatoire"),
  address: Yup.string().required("Adresse obligatoire"),
  reference: Yup.string().required("Référence obligatoire"),
});

type RoleFormData = {
  name: string;
  address: string;
  reference: string;
};

type RoleFormProps = {
  onCreated?: (role: any) => void;
  actioned?: ActionedCustomer | null;
  onClose?: () => void;
  open?: boolean;
};

const CustomerForm = ({
  onCreated,
  actioned,
  onClose,
  open,
}: RoleFormProps) => {
  const roleForm = useFormik<RoleFormData>({
    initialValues: {
      reference: "",
      address: "",
      name: "",
    },
    validationSchema: RoleSchema,
    onSubmit: async (values) => {
      if (roleForm.isValid) {
        const res = actioned
          ? await patchCustomerById(actioned?.data?.id?.toString(), values)
          : await postNewCustomer(roleForm.values);
        if (res) {
          roleForm.resetForm();
          if (onCreated) {
            onCreated(res);
          }
        }
      }
    },
  });

  useEffect(() => {
    if (actioned) {
      roleForm.setValues({
        name: actioned?.data?.name ?? "",
        address: actioned?.data?.address ?? "",
        reference: actioned?.data?.reference ?? "",
      });
    } else {
      roleForm.resetForm();
      roleForm.setTouched({
        name: false,
        address: false,
        reference: false,
      });
    }
  }, [actioned]);
  useEffect(() => {
    roleForm.setTouched({
      name: false,
      address: false,
      reference: false,
    });
  }, [open]);
  if (actioned?.action === "read") {
    return (
      <div className="detail-view">
        {actioned?.data?.name && (
          <div className="d-flex">
            <Form.Label className="fw-bold me-1">
              {"Nom et prénom : "}
            </Form.Label>
            <div>{" " + actioned?.data?.name}</div>
          </div>
        )}
        {actioned?.data?.address && (
          <div className="d-flex">
            <Form.Label className="fw-bold me-1">{"Adresse : "}</Form.Label>
            <div>{" " + actioned.data.address}</div>
          </div>
        )}
        {actioned?.data?.reference && (
          <div className="d-flex">
            <Form.Label className="fw-bold me-1">{"Référence : "}</Form.Label>
            <div>{" " + actioned.data.reference}</div>
          </div>
        )}
      </div>
    );
  }
  return (
    <Form onSubmit={roleForm.handleSubmit}>
      <h4>{"Clients"}</h4>
      <div className="row">
        <div className="col-6">
          <div className="pb-3">
            <Form.Label className="fw-bold">Nom et prénom</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={roleForm.values.name}
              onChange={roleForm.handleChange}
            />
            {roleForm.touched?.name && (
              <span className="text-danger fs-10">
                {roleForm.errors?.name ?? ""}
              </span>
            )}
          </div>
          <div className="pb-3">
            <Form.Label className="fw-bold">Adresse</Form.Label>
            <Form.Control
              type="text"
              name="address"
              value={roleForm.values.address}
              onChange={roleForm.handleChange}
            />
            {roleForm.touched?.address && (
              <span className="text-danger fs-10">
                {roleForm.errors?.address ?? ""}
              </span>
            )}
          </div>
          <div className="pb-3">
            <Form.Label className="fw-bold">Référence</Form.Label>
            <Form.Control
              type="text"
              name="reference"
              value={roleForm.values.reference}
              onChange={roleForm.handleChange}
            />
            {roleForm.touched?.reference && (
              <span className="text-danger fs-10">
                {roleForm.errors?.reference ?? ""}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="pt-2">
        <Button variant="primary" type="submit">
          Enregistrer
        </Button>
      </div>
    </Form>
  );
};

export default CustomerForm;
